module.exports = __webpack_public_path__ + "img/7.19bf9b5c.jpg";